module.exports = __webpack_public_path__ + "static/slide-3-bbfc7da0836e40d5092aefa9f0f667fa.jpg";